/*
  ============================================================
  GYAANSTORE — CENTRAL SALE BADGE TIMER ENGINE
  File: assets/gs-sale-badge.js

  Purpose:
  - Controls ALL .gs-sale-badge badges.
  - Works on product grid and product page.
  - Shows badge only inside gs_sale_start / gs_sale_end.
  - Hides badge before sale starts and after sale ends.

  Important:
  - This file controls timing only.
  - CSS controls design.
  - Liquid only prints hidden badge HTML with date data.
  ============================================================
*/

(function() {
  if (!window.GyaanSaleBadgeEngine) {
    window.GyaanSaleBadgeEngine = (function() {
      var IST_OFFSET = 5.5 * 3600 * 1000;
      var intervalId = null;

      function readNumber(el, name) {
        return parseInt(el.getAttribute(name), 10);
      }

      function isValidDateParts(y, mo, d, h, mi) {
        var dt = new Date(Date.UTC(y, mo - 1, d, h, mi, 0));

        return dt.getUTCFullYear() === y &&
          dt.getUTCMonth() === mo - 1 &&
          dt.getUTCDate() === d &&
          dt.getUTCHours() === h &&
          dt.getUTCMinutes() === mi;
      }

      function toUtcMs(el, prefix) {
        var y  = readNumber(el, 'data-sale-' + prefix + '-year');
        var mo = readNumber(el, 'data-sale-' + prefix + '-month');
        var d  = readNumber(el, 'data-sale-' + prefix + '-day');
        var h  = readNumber(el, 'data-sale-' + prefix + '-hour');
        var mi = readNumber(el, 'data-sale-' + prefix + '-minute');

        if (!isValidDateParts(y, mo, d, h, mi)) {
          return null;
        }

        /*
          Sale dates are written in IST.
          Date.now() is UTC-based.
          So we subtract IST offset for correct comparison.
        */
        return Date.UTC(y, mo - 1, d, h, mi, 0) - IST_OFFSET;
      }

      function showBadge(el) {
        el.hidden = false;
        el.style.display = '';
        el.classList.add('is-active');
        el.setAttribute('aria-hidden', 'false');
      }

      function hideBadge(el) {
        el.classList.remove('is-active');
        el.setAttribute('aria-hidden', 'true');
        el.hidden = true;
        el.style.display = 'none';
      }

      function updateOne(el) {
        var startUTC = toUtcMs(el, 'start');
        var endUTC = toUtcMs(el, 'end');
        var now = Date.now();

        if (startUTC === null || endUTC === null || endUTC <= startUTC) {
          hideBadge(el);
          return;
        }

        if (now >= startUTC && now < endUTC) {
          showBadge(el);
        } else {
          hideBadge(el);
        }
      }

      function refresh() {
        var badges = document.querySelectorAll('[data-gs-sale-badge]');
        badges.forEach(updateOne);
      }

      function start() {
        refresh();

        if (!intervalId) {
          /*
            Sale dates are minute-level.
            Checking every 30 seconds is enough.
            This also fixes tabs left open before/after sale.
          */
          intervalId = setInterval(refresh, 30000);
        }
      }

      document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
          refresh();
        }
      });

      /*
        FETCHED-CARD FIX (2026-07-02):
        Recently viewed / Home recommendations / Shop-by-category tabs / Series nav /
        Author shelf / Wishlist page all inject card HTML AFTER page load. Their sale
        badges arrive hidden and previously stayed hidden until the next 30-second
        poll — so carousels looked like they had "no sale badge" (user report).
        Watch the DOM and refresh as soon as new badge nodes land (debounced so one
        injection burst = one refresh).
      */
      var injectDebounce = null;
      if (window.MutationObserver) {
        new MutationObserver(function(mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              var node = added[j];
              if (node.nodeType !== 1) continue;
              if ((node.hasAttribute && node.hasAttribute('data-gs-sale-badge')) ||
                  (node.querySelector && node.querySelector('[data-gs-sale-badge]'))) {
                if (injectDebounce) window.clearTimeout(injectDebounce);
                injectDebounce = window.setTimeout(refresh, 60);
                return;
              }
            }
          }
        }).observe(document.documentElement, { childList: true, subtree: true });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }

      return {
        refresh: refresh
      };
    })();
  } else {
    window.GyaanSaleBadgeEngine.refresh();
  }
})();
